import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './routes/index'
import store from './store'
//import './registerServiceWorker'
import md5 from 'md5'
import VueSignaturePad from 'vue-signature-pad';
import listAbrechnung from '@/components/abrechnung/list-abrechnung.vue';

Vue.use(VueSignaturePad);

Vue.component('list-abrechnung', listAbrechnung);

Vue.config.productionTip = false
Vue.prototype.client = md5(process.env.VUE_APP_CLIENT_ID)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
